module.exports = __webpack_public_path__ + "img/whats_new_icon.56fe071.svg";